// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__vcEZu","slider":"Switch_slider__biNeT"};